import React from 'react';

/**
 * EditorialCard — Clean, structured editorial container replacing bouncy tilt cards.
 * Fits the modern engineering documentary aesthetic.
 */
const EditorialCard = ({
  children,
  className = '',
  variant = 'standard', // 'standard' | 'technical' | 'featured' | 'emotional'
  onClick,
  style = {}
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'technical':
        return 'technical';
      case 'featured':
        return 'featured';
      case 'emotional':
        return 'emotional';
      default:
        return 'standard';
    }
  };

  return (
    <div
      className={`editorial-card ${getVariantClass()} ${className}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};

export default EditorialCard;
